import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType } from "vue";

/**
 * Пропсы
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmOptionListItemElement',
  props: {
  /**
   * Тег для отображения
   */
  tag: {
    type: String as PropType<string>,
    default: "div",
  },
  /**
   * Наводимый
   */
  isHoverable: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["option-list-item", {
      'option-list-item--hoverable': props.isHoverable,
    }])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})